module.exports = __webpack_public_path__ + "static/media/borrower.2397a300.svg";